import { DpButton } from '@/components/blocks/DpLibrary/DpButton';
import { OTPInput } from '@/components/blocks/OTPInput';
import { Stack } from '@mui/material';
import { useEffect, useState } from 'react';

type Props = {
	otp: string;
	otpError?: string;
	disabled?: boolean;
	cooldownStartedAt?: number;
	sendCooldownSeconds: number;
	onChangeOtp: (otp: string) => void;
	onSubmitLogin: () => void;
	onSubmitOtpMethod: () => void;
	onToggleSelectOtpMethod: () => void;
};

export const LoginOtpStage: React.FC<Props> = ({
	otp,
	otpError,
	disabled,
	cooldownStartedAt,
	sendCooldownSeconds,
	onChangeOtp,
	onSubmitLogin,
	onSubmitOtpMethod,
	onToggleSelectOtpMethod,
}) => {
	const getRemainingTime = () => {
		if (!cooldownStartedAt) return 0;

		const elapsedSeconds = Math.floor((Date.now() - cooldownStartedAt) / 1000);
		return Math.max(sendCooldownSeconds - elapsedSeconds, 0);
	};

	const [remainingTime, setRemainingTime] = useState(getRemainingTime);

	useEffect(() => {
		setRemainingTime(getRemainingTime());

		if (!cooldownStartedAt) return;

		const intervalId = window.setInterval(() => {
			setRemainingTime(getRemainingTime());
		}, 1000);

		return () => window.clearInterval(intervalId);
	}, [cooldownStartedAt, sendCooldownSeconds]);

	const handleOnSendOtp = () => {
		if (remainingTime === 0) {
			onSubmitOtpMethod();
		}
	};

	return (
		<Stack width="100%">
			<OTPInput value={otp} error={otpError} onChange={onChangeOtp} onComplete={onSubmitLogin} />

			<DpButton
				sx={{
					mt: '20px',
					alignSelf: 'flex-end',
					'&:disabled': { color: 'var(--color-text-disabled)', cursor: 'not-allowed' },
				}}
				variant="text"
				disabled={remainingTime > 0}
				onClick={handleOnSendOtp}
			>
				{remainingTime > 0
					? `Reenviar código (${Math.floor(remainingTime / 60)
							.toString()
							.padStart(2, '0')}:${(remainingTime % 60).toString().padStart(2, '0')})`
					: 'Reenviar código'}
			</DpButton>

			<DpButton
				sx={{ mt: '20px', width: '100%', maxWidth: '400px', alignSelf: 'center' }}
				id="button-login-otp-submit"
				disabled={disabled}
				onClick={onSubmitLogin}
			>
				{'Iniciar sesión'}
			</DpButton>

			<DpButton sx={{ mt: '20px' }} variant="text" onClick={onToggleSelectOtpMethod}>
				{'Probar otro método'}
			</DpButton>
		</Stack>
	);
};
